import { render, staticRenderFns } from "./EventGroup.vue?vue&type=template&id=0205fd2e&scoped=true&"
import script from "./EventGroup.vue?vue&type=script&lang=ts&"
export * from "./EventGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EventGroup.vue?vue&type=style&index=0&id=0205fd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205fd2e",
  null
  
)

export default component.exports